'use client';

import { cn } from '@lib/util/cn';

type ToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  'aria-label': string;
};

const Toggle = ({
  checked,
  onChange,
  disabled,
  'aria-label': ariaLabel,
}: ToggleProps) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={ariaLabel}
    disabled={disabled}
    onClick={() => {
      if (!disabled) {
        onChange(!checked);
      }
    }}
    className={cn(
      'relative inline-flex h-6 w-12 shrink-0 rounded-full transition-colors duration-200 ease-in-out focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-neutral-900',
      disabled ? 'cursor-not-allowed' : 'cursor-pointer',
      checked ? 'bg-brand-interactive-600' : 'bg-brand-neutral-300',
    )}
  >
    <span
      aria-hidden="true"
      className={cn(
        'absolute top-0.5 h-5 w-5 rounded-full bg-white shadow-xs transition-transform duration-200 ease-in-out',
        checked ? 'translate-x-[26px]' : 'translate-x-0.5',
      )}
    />
  </button>
);

export default Toggle;
